module.exports = __webpack_public_path__ + "media/customizations/riverlights/logo-d95912cd4269db17d37b62c4b0b271f9.png";